import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";

import { fairyDustCursor } from "cursor-effects";

const root = ReactDOM.createRoot(document.getElementById("root"));

new fairyDustCursor({
  colors: ["#FEA55F", "#ffffff", "#607B96",
    
  ],
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
